import React from 'react';
import '../../../assets/css/StudentShortDetails.css';
import { formatDateDDMMYYYYHHMMSS_UTC } from '../../../Utils/data&dateTime';

const FeePlanShortDetails = ({ selectedFeeDetails }) => {
  const feePlans = selectedFeeDetails?.payment_fee_plan || [];
  console.log("feeplans", feePlans)
  return (
    <>
      {feePlans.length > 0 ? (
        <div className="paymentreporttablecontainer ledgerWrapper"
          style={{ border: "1px solid #E9E9E9", borderRadius: "8px", overflow: "hidden", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
          <div style={{ flex: 1, minHeight: 0, overflowY: "auto", scrollbarWidth: "thin", scrollbarColor: "#d1d5db transparent" }}>
            <table className="table table-sm table-bordered table-hover student-table fee ledgerTable" style={{ marginBottom: 0 }}>
              <thead className="ledgerHeader" style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <tr>
                  <th style={{ padding: "8px 10px" }}>Imposed Date</th>
                  <th style={{ padding: "8px 10px" }}>Fee Head</th>
                  <th style={{ padding: "8px 10px", textAlign: 'right' }}>Imposed Amount</th>
                </tr>
              </thead>
              <tbody className='ledgerBody'>
                {feePlans.map((plan, idx) => (
                  <tr key={idx}>
                    <td style={{ padding: "7px 10px" }}>{formatDateDDMMYYYYHHMMSS_UTC(plan.created_at)}</td>
                    <td style={{ padding: "7px 10px" }}>{plan.fee_type_head}</td>
                    <td style={{ padding: "7px 10px", textAlign: 'right' }}>
                      ₹ {Number(plan.amount).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="ledgerFooter" style={{ position: "sticky", bottom: 0, zIndex: 2 }}>
                <tr>
                  <td colSpan="2" style={{ padding: "8px 10px", fontWeight: 600 }}>Total</td>
                  <td style={{ padding: "8px 10px", textAlign: 'right', fontWeight: 600 }}>
                    ₹ {feePlans.reduce((sum, p) => sum + Number(p.amount || 0), 0).toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      ) : (
        <p className="sd-p planNotFound">No fee plan found for this student</p>
      )}
    </>
  );
};

export default FeePlanShortDetails;
